import { render } from "./id_result.vue?vue&type=template&id=60f597b2&scoped=true&ts=true"
import script from "./id_result.vue?vue&type=script&lang=ts"
export * from "./id_result.vue?vue&type=script&lang=ts"

import "./id_result.vue?vue&type=style&index=0&id=60f597b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f597b2"]])

export default __exports__